import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: ModalLoading General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalLoading.';

  public static readonly loading = `${Id.prefix}loading`;
  public static readonly justAMoment = `${Id.prefix}justAMoment`;
}

export class LangModalLoading {
  private constructor() {}

  public static loading(): string {
    return interpolate(Id.loading);
  }
  public static justAMoment(): string {
    return interpolate(Id.justAMoment);
  }
}

export class ModalLoadingModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.loading, 'Loading', 'Loading dialog title');
    register.add(Id.justAMoment, 'just a moment...', 'Just a moment message for loading');
  }
}
